import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { APP_STORE_URL } from "../content";

const LINKS = [
  { label: "Platform", href: "#features" },
  { label: "Pricing", href: "#pricing" },
  { label: "FAQ", href: "#faq" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled
          ? "border-b-2 border-ink bg-bone/95 backdrop-blur-xl"
          : "border-b-2 border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-16">
        <a
          href="#top"
          data-testid="nav-logo-link"
          className="group flex items-center gap-1"
        >
          <span
            className="text-2xl tracking-tight text-ink transition-colors duration-300 group-hover:text-stone-600 md:text-[1.7rem]"
            style={{ fontFamily: "Georgia, 'Times New Roman', serif" }}
          >
            nt.<span className="align-super text-[0.3em] tracking-normal">™</span>
          </span>
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="font-sans text-xs font-bold uppercase tracking-[0.14em] text-stone-600 transition-colors duration-200 hover:text-ink"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          data-testid="nav-download-btn"
          href={APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="rounded-full border-2 border-ink bg-pastel-pink px-5 py-2 font-sans text-[11px] font-bold uppercase tracking-[0.14em] text-ink shadow-chunk transition-all duration-200 hover:-translate-y-0.5 hover:shadow-chunk-lg"
        >
          Get the app
        </a>
      </div>
    </motion.header>
  );
}
